document.addEventListener('DOMContentLoaded', function () {
  
    window.addEventListener("pageshow", function ( event ) {
      var historyTraversal = event.persisted || ( typeof window.performance != "undefined" && window.performance.navigation.type === 2 );
      if(historyTraversal ) {
        const cleanUrl = window.location.origin + window.location.pathname;
        window.history.replaceState({}, document.title, cleanUrl);
        window.location.reload(true);
      }
    });

  
      function getQueryParam(param) {
          const urlParams = new URLSearchParams(window.location.search);
          return urlParams.get(param);
      }
      const isFormSubmitted = getQueryParam("contact_posted");
      if (isFormSubmitted === "true") {
          setTimeout(() => {
              let target = document.getElementById("ContactForm");
              if (!target) {
                  target = document.querySelector(".contact, .contact-form, .contact-section");
              }
      
              if (target) {
                  target.scrollIntoView({ behavior: "smooth", block: "start" });
                  const yOffset = target.getBoundingClientRect().top + window.pageYOffset - 300;
                  window.scrollTo({ top: yOffset, behavior: "smooth" });
              } else {
              }
          }, 500);
      }
  
    const form = document.getElementById('ContactForm');
    const emailInput = document.getElementById('ContactForm-email');
    const messageInput = document.getElementById('ContactForm-body');
    const firstNameInput = document.getElementById('ContactForm-first-name');
    const lastNameInput = document.getElementById('ContactForm-last-name');
    const submitButton = document.getElementById('CustomSubmitButton');
    const errorIcon = document.getElementById('error-icon')?.innerHTML || '';

  if(submitButton){
    submitButton.addEventListener('click', function (event) {
        let isValid = true;

        // Clear previous error messages
        const errorMessages = form.querySelectorAll('.error-message');
        errorMessages.forEach(error => error.remove());

        // Clear red borders
        [emailInput, messageInput, firstNameInput, lastNameInput].forEach(input => {
            input.classList.remove('inpur-borderclr');
        });

        // First Name Validation
        if (firstNameInput.value.trim() === '') {
            isValid = false;
            const error = document.createElement('small');
            error.classList.add('error-message');
            error.innerHTML = errorIcon + 'Please enter your first name.';
            firstNameInput.parentElement.appendChild(error);
            firstNameInput.classList.add('inpur-borderclr');
        }

        // Last Name Validation
        if (lastNameInput.value.trim() === '') {
            isValid = false;
            const error = document.createElement('small');
            error.classList.add('error-message');
            error.innerHTML = errorIcon + 'Please enter your last name.';
            lastNameInput.parentElement.appendChild(error);
            lastNameInput.classList.add('inpur-borderclr');
        }

        // Email Validation
        const emailValue = emailInput.value.trim();
        if (emailValue === '') {
            isValid = false;
            const error = document.createElement('small');
            error.classList.add('error-message');
            error.innerHTML = errorIcon + `Please enter your email address.`;
            emailInput.parentElement.appendChild(error);
            emailInput.classList.add('inpur-borderclr');
        } else if (!emailValue.includes('@')) {
            isValid = false;
            const username = emailValue.split('@')[0];
            const error = document.createElement('small');
            error.classList.add('error-message');
            error.innerHTML = errorIcon + `Please include an ‘@’ in the email address. ‘${username}’ is missing an ‘@’.`;
            emailInput.parentElement.appendChild(error);
            emailInput.classList.add('inpur-borderclr');
        } else if (!/\S+@\S+\.\S+/.test(emailValue)) {
            isValid = false;
            const error = document.createElement('small');
            error.classList.add('error-message');
            error.innerHTML = errorIcon + `Please enter a valid email address.`;
            emailInput.parentElement.appendChild(error);
            emailInput.classList.add('inpur-borderclr');
        }

        // Message Validation
        const messageText = messageInput.value.trim();
        if (messageText === '') {
            isValid = false;
            const error = document.createElement('small');
            error.classList.add('error-message');
            error.innerHTML = errorIcon + 'Please fill out this field.';
            messageInput.parentElement.appendChild(error);
            messageInput.classList.add('inpur-borderclr');
        } else if (messageText.length < 20) {
            isValid = false;
            const error = document.createElement('small');
            error.classList.add('error-message');
            error.innerHTML = errorIcon + 'Please enter at least 20 characters.';
            messageInput.parentElement.appendChild(error);
            messageInput.classList.add('inpur-borderclr');
        }

        if (!isValid) {
            event.preventDefault();
        }
    });
  }
  
});

